export const buildAppBuilderUrl = ({ appId, tab, initialPrompt, templateId, basePath = 'app-builder', }) => {
    const currentUrl = new URL(window.location.href);
    const targetUrl = new URL(`https://manage.wix.com/apps/${appId}/${basePath}`);
    currentUrl.searchParams.forEach((value, key) => {
        if (!targetUrl.searchParams.has(key)) {
            targetUrl.searchParams.set(key, value);
        }
    });
    targetUrl.searchParams.set('tab', tab);
    targetUrl.searchParams.set('establishDeVibeProject', 'true');
    targetUrl.searchParams.set('initialPrompt', initialPrompt);
    if (templateId) {
        targetUrl.searchParams.set('templateId', templateId);
    }
    return targetUrl.toString();
};
//# sourceMappingURL=buildAppBuilderUrl.js.map